<template>
    <div>
        <c-search-form v-show="step ==0"
                       :rows-per-page-items="[10, 20, 50]"
                       :form-name="formName"
                       :fields="fields"
                       key-property="req_ord_id"
                       search-url="/requestOrder/search"
                       create-url="/requestOrder/save"
                       delete-url="/requestOrder/delete"
                       form-type="intable"
                       ref="tableData"
                       :deleteMulti="false"
                       :acceptView="true"
                       :acceptEdit="false"
                       :acceptDelete="false"
                       :accept-create="false"
                       :acceptNotification="true"
                       custom-create-new
                       custom-edit-item
                       @viewItem="viewItem"
                       @editItem="editItem"
                       @viewNotification="viewNotification"
        >
            <template slot="featureBtn">
                <v-menu
                        :close-on-content-click="true"
                        offset-y
                        origin="center center"
                        class="elelvation-1"
                >
                    <v-btn slot="activator"
                           fab
                           dark
                           small
                           color="light-blue"
                           class="elevation-1"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                    <v-list class="pa-0">
                        <v-list-tile
                                href="#"
                                @click="createNew"
                                ripple="ripple"
                                rel="noopener"
                                key="by_process"
                                :to="null"
                                :target="null"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-react</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Đơn hàng theo quy trình
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                                href="#"
                                @click="createNewPurchaseNotByProcess"
                                ripple="ripple"
                                rel="noopener"
                                key="not_by_process"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-webhook</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Đơn hàng không theo quy trình
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                                href="#"
                                @click="createNewPurchaseService"
                                ripple="ripple"
                                rel="noopener"
                                key="purchase_service"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-office-building</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Mua hàng dịch vụ
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE"
                                     href="#"
                                     @click="createNewAdditionPurchase"
                                     ripple="ripple"
                                     rel="noopener"
                                     key="addition_purchase"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-book-plus-multiple</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Đơn hàng bổ sung
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                </v-menu>
            </template>
        </c-search-form>
        <request-order-create v-show="step==1" @cancel="onCancel" ref="createCpn"/>
        <v-dialog v-model="selectOrderDlg" width="600px" persistent>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">
                            Chọn đề nghị mua hàng bổ sung
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="selectOrderDlg=false"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-select label="Số đề nghị"
                              v-model="selectedRequest"
                              :items="lstUnCompleteOrder"
                              v-validate="'required'"
                              name="selectedRequest"
                              data-vv-as="Số đề nghị"
                              :error-messages="errors.first('selectedRequest')"
                              item-text="requestNumber"
                              item-value="requestNumber"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary" @click="onCreateNewAdditionPurchase">
                        {{ $t("lang.purchase.create") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <import-request-list
                :cDialog="importRequestDlg"
                :hiddenFields="hiddenFieldsNoti"
                @closeDialog="closeImportRequestDlg"
        />
        <acceptance-report-list
                :cDialog="acceptanceReportDlg"
                :hiddenFields="hiddenFieldsNoti"
                @closeDialog="closeAcceptanceReportDlg"
        />
    </div>
</template>

<script>
    import CSearchForm from "../../../components/form/ManageForm";
    import axios from "axios";
    import {requestConstants, roleConstants} from "@/constants";
    import RequestOrderCreate from "./RequestOrderCreate";
    import ImportRequestList from "./component/ImportRequestList";
    import AcceptanceReportList from "./component/AcceptanceReportList";

    export default {
        name: "request_order",
        components: {RequestOrderCreate, CSearchForm, ImportRequestList, AcceptanceReportList},
        data: () => {
            return {
                step: 0,
                formName: "Danh sách đề nghị mua hàng",
                propsItem: null,
                visibleCreateDialog: false,
                pondType: [],
                areas: [],
                timeReload: 0,
                requestOrderId: null,
                requestOrder: null,
                selectOrderDlg: false,
                importRequestDlg: false,
                acceptanceReportDlg: false,
                selectedRequest: null,
                lstUnCompleteOrder: null,
                hiddenFields: {
                    typeId: "0",
                },
                hiddenFieldsNoti: {},
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        sortable: false,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "requestNumber",
                        text: "Số đề nghị",
                        search: true,
                        headerStyle: "text-align:left",
                    },
                    {
                        value: "requestDate",
                        text: "Ngày đề nghị",
                        headerStyle: "text-align:center",
                        dateFormat: 'dd/MM/yyyy',
                        type: "date",
                        search: true,
                        fromDate: "fromDate",
                        toDate: "toDate"
                    },
                    {
                        value: "areaId",
                        text: "Khu nuôi",
                        search: true,
                        headerStyle: "text-align:center",
                        type: "select",
                        name: "areaId",
                        items: [],
                        itemText: "categoryName",
                        itemValue: "categoryId",
                    },
                    {
                        value: "content",
                        text: "Nội dung",
                        search: true,
                        headerStyle: "text-align:center",
                        contentStyle: "text-align:left",
                        name: "content",
                    },
                    {
                        value: "status",
                        text: "lang.user.status",
                        search: true,
                        headerStyle: "text-align:center",
                        type: "select",
                        name: "status",
                        items: requestConstants.requestStatus["ALL"],
                        itemText: "text",
                        itemValue: "value",
                    },
                    {
                        value: "totalImportRequest",
                        text: "Số thông báo đã tạo",
                        headerStyle: "text-align:center",
                        renderItem: (item) => {
                            let number = item.totalImportRequest;
                            if (item.byProcess == 3) {
                                number = item.totalAcceptanceReport;
                            }
                            return number + ' ';
                        },
                    },
                    {
                        value: "action",
                        width: "5%",
                        text: "lang.common.actions",
                        compound: true,
                        headerStyle: "text-align:center; width: 125px;",
                    },
                ],
            };
        },

        created() {
            // khu nuôi
            this.roleConstants = roleConstants;
            axios
                .post(
                    process.env.VUE_APP_API_URL +
                    "/category/myArea"
                )
                .then((data) => {
                    if (data.length > 0) {
                        this.areas = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "areaId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                });
            let role = this.$store.state.auth.user.role;
            if (role == 1) {
                let itemFields = this.fields.filter(function (e) {
                    return e.name == "status";
                });
                if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = requestConstants.requestStatus["DIRECTOR"];
                }

            }
        },

        computed: {},

        methods: {
            canEdit(item) {
                if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE) {
                    return false;
                } else {
                    //console.log(item.status);
                    //console.log(requestConstants.requestStatus["STATUS"]);
                    if (item.status == requestConstants.requestStatus["STATUS"].WAIT_CHECK
                    ) {
                        //console.log("can edit");
                        return true;
                    } else return false;
                }
            },

            getUnCompleteRequest() {
                axios.post(process.env.VUE_APP_API_URL + "/requestOrder/search?page=-1&pageSize=-1", {
                    status: 5,
                    incomplete: 1
                }).then(
                    data => {
                        this.lstUnCompleteOrder = data.items;
                    }
                )
            },
            getLstNeedSupplement() {
                axios.post(process.env.VUE_APP_API_URL + "/requestOrder/getNeedSupplement?page=-1&pageSize=-1", {isProcess:1}).then(
                    data => {
                        this.lstNeedSupplement = data.items;
                    }
                )
            },

            createNew() {
                this.openCreateDialog(null, 0);
            },

            createNewPurchaseNotByProcess() {
                this.openCreateDialog(null, 1);
            },

            createNewPurchaseService() {
                this.openCreateDialog(null, 3);
            },

            onCreateNewAdditionPurchase() {
                //
                // set new order
                //
                this.selectOrderDlg = false;
                let pR = this.lstUnCompleteOrder.filter(order => {
                    return order.requestNumber == this.selectedRequest;
                })[0];
                //
                // get import_order request
                //
                axios.post(process.env.VUE_APP_API_URL + "/requestOrder/search?page=-1&pageSize=-1", {
                    status: 6,
                    requestNumber: pR.requestNumber + "A",
                    byProcess: 2
                }).then(
                    addditionRQ => {
                        axios.post(process.env.VUE_APP_API_URL + "/importWh/getByPurchaseOfRequestNumber?purchaseRequestNumber=" + pR.requestNumber).then(
                            data => {
                                //
                                // tinh toan
                                //
                                //let iR = data[0];
                                this.calculateAdditionRequest(pR, data, addditionRQ.items);
                            }
                        )
                    }
                );
            },

            calculateAdditionRequest(pR, data, additionsRQ) {
                let requestData = JSON.parse(pR.requestData);
                // console.log(requestData);
                // console.log(requestData.lstMaterial);
                let additions = [];
                for(let i=0;i<additionsRQ.length;i++){
                    let rqdata = JSON.parse(additionsRQ[i].requestData);
                    additions.push(rqdata);
                }
                for (let i = requestData.lstMaterial.length - 1; i >= 0; i--) {
                    if (requestData.lstMaterial[i].materialId != undefined && requestData.lstMaterial[i].materialId != null) {
                        //
                        // check addition
                        //
                        let add = 0;
                        for(let j=0;j<additions.length;j++){
                            for(let h=0;h<additions[j].lstMaterial.length;h++){
                                if (requestData.lstMaterial[i].materialId == additions[j].lstMaterial[h].materialId){
                                    add += additions[j].lstMaterial[h].buyNumberAddition;
                                }
                            }
                        }

                        let total = 0 - parseFloat(requestData.lstMaterial[i].buyNumberPropose) - add;
                        let actualImport = 0;
                        for (let h = 0; h < data.length; h++) {
                            let iR = data[h];
                            let ird = JSON.parse(iR.requestData);
                            console.log(ird);
                            //debugger;
                            for (let j = 0; j < ird.length; j++) {
                                if (requestData.lstMaterial[i].materialId == ird[j].materialId) {
                                    total += parseFloat(ird[j].actualImport);
                                    actualImport += parseFloat(ird[j].actualImport);
                                    break;
                                }
                            }
                        }
                        if (total < 0) {
                            total = 0;
                        }
                        requestData.lstMaterial[i].buyNumberAddition = total;
                        requestData.lstMaterial[i].actualImport = actualImport;
                        if (requestData.lstMaterial[i].buyNumberAddition == 0 || requestData.lstMaterial[i].buyNumberAddition == undefined || requestData.lstMaterial[i].buyNumberAddition == null) {
                            delete requestData.lstMaterial[i];
                            requestData.lstMaterial.splice(i, 1);
                        } else {
                            requestData.lstMaterial[i].money = requestData.lstMaterial[i].buyNumberAddition * parseFloat(requestData.lstMaterial[i].price);
                        }
                        //console.log(requestData);
                    }
                }
                let item = {
                    requestDate: new Date(),
                    requestNumber: pR.requestNumber + "A",
                    originalRequest: pR.requestNumber,
                    materialType: pR.materialType,
                    areaId: pR.areaId,
                    content: pR.content,
                    byProcess: 2,
                    userCreateId: this.$store.state.auth.user.userId,
                    userCreateName: this.$store.state.auth.user.fullName,
                    requestData: JSON.stringify(requestData),
                    status: 1,
                }
                // console.log(item);
                this.openCreateDialog(item, 2);

            },

            createNewAdditionPurchase() {
                this.getUnCompleteRequest();
                this.getLstNeedSupplement()
                this.selectOrderDlg = true;
            },

            openCreateDialog(item = null, byProcess) {
                this.requestOrderId = null;
                this.requestOrder = null;
                this.$refs.createCpn.editOrder(item, byProcess);
                this.step = 1;
            },

            editItem(item) {
                this.requestOrderId = item.reqOrdId;
                this.requestOrder = item;
                this.step = 1;
                this.$refs.createCpn.editOrder(item);
            },
            viewItem(item) {
                // console.log('-------viewItem---------');
                // console.log(item);
                this.requestOrderId = item.reqOrdId;
                this.requestOrder = item;
                this.step = 1;
                if (this.canEdit(item)) {
                    this.$refs.createCpn.editOrder(item, item.byProcess);
                } else {
                    this.$refs.createCpn.viewOrder(item);
                }
            },
            onCancel() {
                this.step = 0;
                this.$refs.tableData.onSearch();
            },
            closeImportRequestDlg() {
                this.importRequestDlg = false;
            },
            viewNotification(item) {
                console.log(item);
                // this.importRequestDlg = true;

                if (item.byProcess == 3) {
                    this.acceptanceReportDlg = true;
                } else {
                    this.importRequestDlg = true;
                }

                this.hiddenFieldsNoti = {
                    reqOrdId: item.reqOrdId,
                };
            },
            closeAcceptanceReportDlg() {
                this.acceptanceReportDlg = false;
            },
        },
        destroyed() {
        },
    };
</script>
